import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75182bbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-label" }
const _hoisted_2 = {
  key: 0,
  class: "text-label__instructions"
}

interface Props {
	instructions?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TextLabel',
  props: {
    instructions: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.instructions)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.instructions), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})